import { type ObjectValuesUnionType } from '../../../utils/typing';

export const BOOM_PREFIX = 'BOOM';

export const BoomGlobalStatuses = Object.freeze({
  RUNNING: 'RUNNING',
  ENDING: 'ENDING',
});

export type BoomGlobalStatus = ObjectValuesUnionType<typeof BoomGlobalStatuses>;

export const BoomSkinIds = Object.freeze({
  HALLOWEEN: 'HALLOWEEN',
  VALENTINE: 'VALENTINE',
  PATRICK: 'PATRICK',
});

export type BoomSkinId = ObjectValuesUnionType<typeof BoomSkinIds>;
